module.exports = __webpack_public_path__ + "img/inner-layer.36fe579e.svg";